/**
 * Created by Administrador on 20/07/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('transference', {
                parent: 'app',
                url: '/transference',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargo/transference/transference.html',
                        controller: 'transferenceCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoOperationReport('transference')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReport']);
                            }],
                            'branchOffices': ['branchOfficeService', function(branchOfficeService){
                                return branchOfficeService.getBranchOfficesCargo(true)
                            }]
                        }
                    }
                }
            });
    }
})();
